import { render, staticRenderFns } from "./InsightsComp.vue?vue&type=template&id=78df6566&scoped=true&"
import script from "./InsightsComp.vue?vue&type=script&lang=ts&"
export * from "./InsightsComp.vue?vue&type=script&lang=ts&"
import style0 from "./InsightsComp.vue?vue&type=style&index=0&id=78df6566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78df6566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VProgressCircular})
